import { http } from "../utils/http";

export const getTestResultImage = (resultId) =>
    http.getBlob(`/test/results/${resultId}/image`);

export const getTests = () =>
    http.get("/tests").catch(err => {
        if (err?.message?.includes("not found") || err?.message?.includes("404")) return [];
        throw err;
    });

/** Правка №1: цифры по каждому тесту для карточек «Создание тестов». */
export const getTestsStats = () => http.get("/tests/stats");

export const getTest = (id) =>
        http.get(`/test/${id}`).catch(err => {
        if (err?.message?.includes("not found") || err?.message?.includes("404")) return null;
        throw err;
    });

export const listExternalTestResults = ({ test_id, candidate_id, q } = {}) => {
    const params = new URLSearchParams();
    if (test_id != null && test_id !== "") params.set("test_id", String(test_id));
    if (candidate_id != null && candidate_id !== "") params.set("candidate_id", String(candidate_id));
    if (q) params.set("q", q);
    const query = params.toString();
    return http.get(`/external-test-results${query ? `?${query}` : ""}`).catch((err) => {
        // Keep the results page available during a rolling backend/frontend deploy.
        if (err?.message?.includes("not found") || err?.message?.includes("404")) return [];
        throw err;
    });
};

export const createTest = (data) => http.post("/test", data);
export const updateTest = (id, data) => http.put(`/test/${id}`, data);
export const deleteTest = (id) => http.del(`/test/${id}`);

export const createTestEditorDraft = (state) =>
    http.post("/test/editor-drafts", { state });
export const getTestEditorDraft = (id) =>
    http.get(`/test/${id}/editor-draft`);
export const saveTestEditorDraft = (id, state) =>
    http.put(`/test/${id}/editor-draft`, { state });
export const publishTestEditorDraft = (id) =>
    http.post(`/test/${id}/publish`, {});
export const discardTestEditorDraft = (id) =>
    http.post(`/test/${id}/discard-draft`, {});
export const uploadTestConsentDocument = (id, file) => {
    const body = new FormData();
    body.append("file", file);
    return http.post(`/test/${id}/consent-document`, body);
};
export const deleteTestConsentDocument = (id) =>
    http.del(`/test/${id}/consent-document`);

/** Append questions (legacy). Prefer replaceTestQuestions for form save. */
export const createTestQuestions = (testId, questions) =>
    http.post(`/test/${testId}/questions`, questions);

/** Replace full question list (create/edit form save). */
export const replaceTestQuestions = (testId, questions) =>
    http.put(`/test/${testId}/questions`, questions);

export const addTestsToVacancy = (vacancyId, testIds) =>
    http.post(`/vacancy/${vacancyId}/add_tests`, { test_ids: (testIds ?? []).map(Number) });

export const updateTestForVacancy = (
    vacancyId,
    testIds,
    invitationMessage = null,
    deliveryFilters = {},
) =>
    http.put(`/vacancy/${vacancyId}/update_tests`, {
        test_ids: (testIds ?? []).map(Number),
        invitation_message: invitationMessage,
        delivery_filters: Object.fromEntries(
            (testIds ?? []).map((testId) => [Number(testId), deliveryFilters?.[testId] || "all"])
        ),
    });

export const getTestForVacancy = (vacancyId) =>
    http.get(`/vacancy/${vacancyId}/tests`).catch(err => {
        if (err?.message?.includes("not found") || err?.message?.includes("404")) return [];
        throw err;
    });

export const getVacancyTestSettings = (vacancyId) =>
    http.get(`/vacancy/${vacancyId}/test-settings`);

export const getVacancyTestSettingsLibrary = () =>
    http.get("/vacancy-test-settings");

export const createVacancyTestSetting = (payload) =>
    http.post("/vacancy-test-settings", payload);

export const updateVacancyTestSetting = (settingId, payload) =>
    http.put(`/vacancy-test-settings/${Number(settingId)}`, payload);

export const assignVacancyTestSetting = (vacancyId, settingId) =>
    http.put(`/vacancy/${Number(vacancyId)}/test-setting`, {
        setting_id: settingId == null ? null : Number(settingId),
    });

export const createAndAssignVacancyTestSetting = (vacancyId, payload) =>
    http.post(`/vacancy/${Number(vacancyId)}/test-setting/new`, payload);

export const updateAndAssignVacancyTestSetting = (vacancyId, settingId, payload) =>
    http.put(
        `/vacancy/${Number(vacancyId)}/test-setting/${Number(settingId)}`,
        payload,
    );
